import { Divider, Flex } from "styled-system/jsx";
import { Heading, Text, ButtonProps, Button, Icon } from "@ttc3k/trekker";
import { ReactNode } from "react";

export interface PageHeaderProps {
  title: string;
  description?: string;
  ctaButtonProps?: ButtonProps;
  ctaButtonCopy?: string;
  ctaButtonReplacement?: ReactNode;
  Icon?: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, "ref"> &
      React.RefAttributes<SVGSVGElement>
  >;
}

export const PageHeader = ({
  Icon: IconElement,
  title,
  description,
  ctaButtonProps,
  ctaButtonCopy,
  ctaButtonReplacement,
}: PageHeaderProps) => {
  const showButton = ctaButtonProps && ctaButtonCopy && !ctaButtonReplacement;

  return (
    <Flex direction={"column"} gap={"300"} w={"full"}>
      {/* Height is set to not have layout shift if button is shown */}
      <Flex justify={"space-between"} alignItems={"center"} h={"48px"}>
        <Heading
          size={"h4"}
          display="flex"
          flexDir="row"
          alignItems="center"
          gap="150"
        >
          {IconElement && <Icon Element={IconElement} size="xl" />}
          {title}
        </Heading>
        {showButton && (
          <Button
            visual={"primary"}
            mode={"light"}
            size={"lg"}
            {...ctaButtonProps}
          >
            {ctaButtonCopy}
          </Button>
        )}
        {ctaButtonReplacement && ctaButtonReplacement}
      </Flex>
      <Divider borderColor={"border.light"} borderBottomWidth={"2px"} />
      {description && <Text visual={"bodyMedium"}>{description}</Text>}
    </Flex>
  );
};
